import t, { forwardRef as i } from "react";
import { c, t as p } from "./useKeyDown-88662051.mjs";
import { I as b, W as _ } from "./Icon-e01b6482.mjs";
import { u as N } from "./app-51178863.mjs";
const S = "button", d = "button__default-focus-style-in-link", z = "button__primary-focus-style-in-link", f = "button__map", k = "button__primary", H = "button__menu-talent", I = "button__arrows", L = "button__secondary", T = "button__quiz", x = "button__menu-employer", Q = "employer", M = "desktop", D = "button__hero", P = "button__hero-talents", B = "button__hero-employer", R = "button__save-container", F = "button__save", w = "button__menu", A = "button__icon", h = "button__icon__container", q = "button__link", O = "button__quiz__label", g = "mobile", V = "button__quiz__divider", W = "button__quiz__text", G = "button__quiz__correct", U = "button__quiz__incorrect", e = {
  button: S,
  buttonDefaultFocusStyleInLink: d,
  buttonPrimaryFocusStyleInLink: z,
  buttonMap: f,
  buttonPrimary: k,
  buttonMenuTalent: H,
  buttonArrows: I,
  buttonSecondary: L,
  buttonQuiz: T,
  buttonMenuEmployer: x,
  employer: Q,
  desktop: M,
  buttonHero: D,
  buttonHeroTalents: P,
  buttonHeroEmployer: B,
  buttonSaveContainer: R,
  buttonSave: F,
  buttonMenu: w,
  buttonIcon: A,
  buttonIconContainer: h,
  buttonLink: q,
  buttonQuizLabel: O,
  mobile: g,
  buttonQuizDivider: V,
  buttonQuizText: W,
  buttonQuizCorrect: G,
  buttonQuizIncorrect: U
}, rt = {
  Default: i($),
  HeroTalents: i(Y),
  HeroEmployer: i(Z),
  Primary: i(j),
  Secondary: i(J),
  Save: i(K),
  Arrow: i(X),
  Menu: i(tt),
  IconLabel: i(et),
  DefaultFocusStyleInLink: e.buttonDefaultFocusStyleInLink,
  PrimaryFocusStyleInLink: e.buttonPrimaryFocusStyleInLink,
  Quiz: i(nt),
  Link: i(ot)
};
function $({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    a,
    {
      ...o,
      ref: n,
      className: c(e.button, o.className)
    },
    /* @__PURE__ */ t.createElement("span", { className: c(p.buttonTextPrimary) }, o.text),
    o.icon ? /* @__PURE__ */ t.createElement(b, { icon: o.icon, size: 14 }) : null
  );
}
function j(u, o) {
  const { icon: n, text: a, onClick: s, asDiv: r, preventEmployerStyle: l, ...m } = u, y = N(), E = r ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    E,
    {
      type: "button",
      ...m,
      className: c(
        e.button,
        e.buttonPrimary,
        y && !l && e.employer,
        u.className
      ),
      onClick: s,
      ref: o
    },
    /* @__PURE__ */ t.createElement("div", { className: e.buttonMap }, /* @__PURE__ */ t.createElement("span", { className: c(p.buttonTextPrimary) }, a), n ? /* @__PURE__ */ t.createElement(b, { icon: n, size: 12 }) : null)
  );
}
function J(u, o) {
  const {
    icon: n,
    text: a,
    onClick: s,
    asDiv: r,
    preventEmployerStyle: l,
    iconPosition: m,
    ...y
  } = u, E = N(), v = r ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    v,
    {
      className: c(
        e.button,
        e.buttonSecondary,
        E && !l && e.employer,
        u.className
      ),
      onClick: s,
      type: "button",
      ...y,
      ref: o
    },
    /* @__PURE__ */ t.createElement("div", { className: e.buttonMap }, n && m === "left" ? /* @__PURE__ */ t.createElement(b, { icon: n, size: 12 }) : null, /* @__PURE__ */ t.createElement("span", { className: c(p.buttonTextPrimary) }, a), n && m !== "left" ? /* @__PURE__ */ t.createElement(b, { icon: n, size: 12 }) : null)
  );
}
function K({ iconFilled: u, className: o, containerClassName: n, ...a }, s) {
  const r = c(
    e.buttonSaveContainer,
    n ?? ""
  );
  return /* @__PURE__ */ t.createElement("div", { className: r }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      ...a,
      className: c(e.button, e.buttonSave, o),
      ref: s,
      "aria-label": "save"
    },
    /* @__PURE__ */ t.createElement(
      b,
      {
        icon: u ? _.HEART_FILLED : _.HEART,
        size: 20
      }
    )
  ));
}
function X({ arrowDirection: u, className: o, ...n }, a) {
  const s = (r) => {
    switch (r) {
      case "up":
        return _.CHEVRON_UP;
      case "down":
        return _.CHEVRON_DOWN;
      case "left":
        return _.CHEVRON_LEFT;
      case "right":
      default:
        return _.CHEVRON_RIGHT;
    }
  };
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      ...n,
      className: c(e.button, e.buttonArrows, o),
      ref: a,
      "aria-label": `arrow-${u}`
    },
    /* @__PURE__ */ t.createElement(b, { size: 20, icon: s(u) })
  );
}
function Y({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    a,
    {
      type: "button",
      ...o,
      className: c(e.button, e.buttonHeroTalents, o.className),
      ref: n
    },
    /* @__PURE__ */ t.createElement("span", { className: c(p.buttonHeroTitle) }, o.text)
  );
}
function Z({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    a,
    {
      type: "button",
      ...o,
      className: c(
        e.button,
        e.buttonHeroEmployer,
        o.className
      ),
      ref: n
    },
    /* @__PURE__ */ t.createElement("span", { className: c(p.buttonHeroTitle) }, o.text)
  );
}
function tt({ asDiv: u, isMenuOpen: o, ...n }, a) {
  const s = u ? "div" : "button", l = N() ? e.buttonMenuEmployer : e.buttonMenuTalent;
  return /* @__PURE__ */ t.createElement(
    s,
    {
      type: "button",
      ...n,
      className: c(
        e.button,
        e.buttonMenu,
        l,
        n.className
      ),
      ref: a,
      "aria-label": o ? "Close" : "Menu"
    },
    o ? /* @__PURE__ */ t.createElement(b, { icon: _.CLOSE }) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(b, { icon: _.SEARCH }), /* @__PURE__ */ t.createElement(b, { icon: _.HAMBURGER }))
  );
}
function et(u, o) {
  const { icon: n, text: a, textClassName: s, onClick: r, buttonClassName: l, ...m } = u, y = c("button " + e.buttonIcon, l), E = c(p.textsLeadText, s);
  return /* @__PURE__ */ t.createElement("button", { className: y, onClick: r, type: "button", ...m, ref: o }, /* @__PURE__ */ t.createElement("div", { className: e.buttonIconContainer }, /* @__PURE__ */ t.createElement("span", { className: E }, a), n && /* @__PURE__ */ t.createElement(
    b,
    {
      icon: n.type,
      size: n.size,
      className: n.className,
      color: n.color
    }
  )));
}
function nt(u, o) {
  const {
    icon: n,
    text: a,
    onClick: s,
    asDiv: r,
    preventEmployerStyle: l,
    label: m,
    customClass: y,
    ...E
  } = u, v = N(), C = r ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    C,
    {
      className: c(
        e.button,
        e.buttonQuiz,
        v && !l && e.employer,
        y
      ),
      onClick: s,
      ...E,
      ref: o
    },
    /* @__PURE__ */ t.createElement("div", { className: e.buttonMap }, /* @__PURE__ */ t.createElement("span", { className: e.buttonQuizLabel }, m), /* @__PURE__ */ t.createElement("span", { className: e.buttonQuizDivider }), /* @__PURE__ */ t.createElement("span", { className: e.buttonQuizText }, a), n ? /* @__PURE__ */ t.createElement(b, { icon: n, size: 29 }) : null)
  );
}
function ot(u, o) {
  const {
    onClick: n,
    asDiv: a,
    preventEmployerStyle: s,
    label: r,
    customClass: l,
    ...m
  } = u, y = N(), E = a ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    E,
    {
      className: c(
        e.button,
        e.buttonLink,
        y && !s && e.employer,
        l
      ),
      onClick: n,
      type: "button",
      ...m,
      ref: o
    },
    r
  );
}
export {
  rt as B
};
//# sourceMappingURL=Button-eec2778c.mjs.map
